import React from 'react';
import { OrderTimelineEvent } from '@components/common/OrderTimelineEvent';
import { useDashboardPermissions } from '@components/utils/DashboardPermissions';
import { useShopTime } from '@modules/Timezone/providers/ShopTimeProvider';
import { useTimelineQuery } from '../queries/useTimelineQuery';
export const useOrderTimelineEvents = (orderId, { enabled } = { enabled: true }) => {
    const { hasPermission } = useDashboardPermissions();
    const timelineEnabled = hasPermission('contributions.orders.timelines') && enabled;
    const { timelineQuery } = useTimelineQuery([orderId], { enabled: timelineEnabled });
    const { toShopTime } = useShopTime();
    const events = timelineQuery.data?.events?.map((timelineEvent) => ({
        ...timelineEvent,
        description: React.createElement(OrderTimelineEvent, { timelineEvent: timelineEvent }),
        happenedAt: toShopTime(timelineEvent.happenedAt),
    })) || [];
    const fulfillments = timelineQuery?.data?.fulfillments
        ?.filter((timelineFulfillment) => timelineFulfillment.shipments[0]?.deliveryEstimate)
        .map((timelineFulfillment) => ({
        id: timelineFulfillment.fulfillmentId,
        description: React.createElement(OrderTimelineEvent, { timelineFulfillment: timelineFulfillment }),
    })) || [];
    return {
        timelineEvents: [...fulfillments, ...events],
        isLoading: timelineQuery.isLoading,
        isFetching: timelineQuery.isFetching,
        isFetched: timelineQuery.isFetched,
    };
};
